export const divisionDeskForm = {
    id: 'divisionDeskForm',
    fields: [
        {
            fieldName: 'name',
            label: 'Name',
            type: 'text',
            required: true,
        },
    ],
};

export const formListConfig = {
    formListForm: {
        id: 'peopleAuthrizedPersonInfo',
        fields: [
            {
                fieldName: 'name',
                label: 'Name',
                type: 'text',
                required: true,
            },
            { fieldName: 'active', label: 'Active', component: 'switch' },
        ],
        slackConfigFields: [
            {
                fieldName: 'slackGroupAgentId',
                label: 'Agents',
                type: 'text',
                required: false,
            },
            {
                fieldName: 'slackGroupTeamLeaderId',
                label: 'Team Leaders',
                type: 'text',
                required: false,
            },
        ],
    },

    formListFormModal: {
        id: 'peopleInfo',
        fields: [
            {
                fieldName: 'name',
                label: 'Name',
                type: 'text',
                required: true,
            },

            {
                fieldName: 'industryType',
                label: 'Industry Type',
                type: 'text',
                initialValue: '',
                // required: true,
                disabled: false,
                lookup: {
                    displayExpr: 'industryType',
                    valueExpr: 'industryType',
                },
            },
        ],
    },
    formListDesks: {
        id: 'peopleAuthrizedPersonInfo',
        fields: [
            {
                fieldName: 'id',
                label: 'Id',
                type: 'text',
                required: true,
            },
            {
                fieldName: 'name',
                label: 'Name',
                type: 'text',
                required: true,
            },
        ],
    },
};
